import * as z from 'zod';
import * as subsidiaryFunctions from './functions';

export const SubsidiarySchema = z.object({
    'id': z.number(),
    'is_active': z.boolean(),
    'name': z.string(),
    'is_training': z.boolean(),
    'pennylane_api_key': z.string().nullable().optional()
});

export const SubsidiarySchemaPartialSchema = SubsidiarySchema.partial();
export type SubsidiaryPartial = z.infer<typeof SubsidiarySchemaPartialSchema>;
export type Subsidiary = z.infer<typeof SubsidiarySchema>;

export function newSubsidiary(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...SubsidiarySchema.parse({...data}),
        ...subsidiaryFunctions
    };
}

export function parseSubsidiary(data: any, partial = false) {
    if (!partial) {
        return {
            ...SubsidiarySchema.parse(data),
            ...subsidiaryFunctions
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...SubsidiarySchema.parse(data),
            ...subsidiaryFunctions
        };
    }
}
